import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import { TrackPlay } from 'react-huge-icons/solid'
import PlanSection from "./plan-section";
import { useTranslation } from "react-i18next";
import { Plan, useEndActiveWorkoutMutation, useStartActiveWorkoutMutation, Workout } from "src/graphql";

interface PlanWorkoutsSectionProps {
    workouts: Partial<Workout>[]
    plan: Partial<Plan>;
}
const PlanWorkoutsSection: React.FC<PlanWorkoutsSectionProps> = ({ workouts, plan }) => {

    const [startingId, setStartingId] = useState<string>()
    const navigate = useNavigate();

    const [finishWorkout, { loading: FinishWorkoutPending }] = useEndActiveWorkoutMutation();

    const [startWorkout, { loading: startWorkoutLoading, error }] = useStartActiveWorkoutMutation({
        onCompleted() {
            navigate('/active?active=1')
        },
        onError(err) {
            if (err.message === "Active Workout already exists") {
                const res = global.confirm("האם ברצונך לסיים אימון פעיל ולהתחיל את האימון הנבחר?")

                if (res) {
                    finishWorkout({
                        onCompleted(data) {
                            startWorkout({
                                variables: {
                                    workoutId: startingId!
                                }
                            })
                        }
                    })
                }
            }
        },

    })



    const { t, i18n: { dir } } = useTranslation();


    return (

        <section>
            <article>
                <h1>{t("your_plan")}</h1>
                <PlanSection activePlan={plan} />
                {workouts.length === 0 ? <div>{t("no_workouts_plan")}</div> :
                    workouts.map((w) => <div className="items-center gap-x-2 flex justify-center flex-col py-2">
                        <h2 className="m-0 text-xl">{w.name}</h2>
                        <div className="w-full">
                            <Button loading={startingId === w.id} disabled={startWorkoutLoading} onClick={async () => {
                                setStartingId(w.id)
                                await startWorkout({
                                    variables: {
                                        workoutId: w.id!,
                                    }
                                })
                                setStartingId(undefined)
                            }} sm>
                                <TrackPlay fontSize={20} className={`${dir() === 'rtl' && "rotate-180"}`} /> <span>{t("start_workout")}</span>
                            </Button>
                        </div>
                    </div>)}
                {error?.message.startsWith("Active") && <p className=" text-green-600 py-2">{t("Active workout already started.")} <Link className="text-blue" to="/active">{t("click_here")}</Link> {t("to_finish")}</p>}
            </article>
        </section >
    );
}

export default PlanWorkoutsSection;